import { useState, useEffect } from "react";
import "./SummerCamp.css";

import Testimonials from "../MyComponents/Testimonials.js"
import FAQ from "../MyComponents/FooterPages/newfaq.js"
// import Navbar from "../MyComponents/Navbars/GuestNav"
import Footer from "../MyComponents/Footer.js"
import heroContent from './StemCourses/HeroContent.js';
import API_CONFIG from "../config/api";

import { Helmet } from "react-helmet";


// import Testimonials from "../components/Testimonials"
import CertificateVerification from "../MyComponents/CertificateVerification.js";

import SumCourses from "./SumCourses.js";
import pencilIcon from "../assets/pencil.png";
import AdvantagesSection from "../MyComponents/PromotionalPages/AdvantagesSection.js";
import HeadSection from "./HeadSection.js";
import GallerySection from "../MyComponents/GallerySection";
const LifeSkillCourses = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    // Ensures Comic Sans is loaded (will be handled by @import in CSS)
  }, []);
  const SummerCamp = heroContent.SummerCamp;
  if (!SummerCamp) {
    return <div>Error: Hero content not found.</div>;
  }
  const advantages = [
    {
      imgSrc: "Polymath-images/Menu Pages/Summer/Features/Group.png",
      alt: "Live Classes",
      title: "Live Classes",
      text: "Real-time, interactive sessions with expert instructors.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Summer/Features/Group-1.png",
      alt: "Global Access",
      title: "Global Access",
      text: "Join from anywhere in the world.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Summer/Features/Mask group.png",
      alt: "Wide Course Variety",
      title: "Wide Course Variety",
      text: "From coding to creativity—something for every child.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Summer/Features/Group-2.png",
      alt: "Fast-Track Format",
      title: "Fast-Track Format",
      text: "Complete a full course in just weeks.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Summer/Features/Group 1686552301.png",
      alt: "Certified Completion",
      title: "Certified Completion",
      text: "Earn digital certificates for each course finished.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Summer/Features/Clip path group.png",
      alt: "Fun + Education",
      title: "Fun + Education",
      text: "Exciting lessons that keep kids engaged and learning.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Summer/Features/Clip path group-1.png",
      alt: "Age-Specific Programs",
      title: "Age-Specific Programs",
      text: "Tailored content for every age group.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Summer/Features/Clip path group-2.png",
      alt: "Confidence Building",
      title: "Confidence Building",
      text: "Hands-on projects and participation videos.",
    },
    {
      imgSrc: "Polymath-images/Menu Pages/Summer/Features/Mask group-1.png",
      alt: "Big Summer Discounts",
      title: "Big Summer Discounts",
      text: "Special pricing only available this summer.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Summer Camp for Kids | Polymath Online STEAM Courses</title>
        <meta name="description" content="Enroll your child in Polymath Summer Camp 2025. Fun, interactive online courses in coding, design & engineering. Free demo & limited seats." />
      </Helmet>
      {/* <Navbar/> */}
      {/* <Hero2
              titlePart1={SummerCamp.titlePart1}
              titlePart2={SummerCamp.titlePart2}
              description={SummerCamp.description}
              // buttonText={SummerCamp.buttonText}
              leftImage={leftimgs}
              rightImage={rightimgs}
     /> */}
      {/* <section className="summer-camp-hero">
  <div className="shero-wrapper">
    <div className="shero-left">
      <img src={leftimgs} alt="Kid with laptop" />
    </div>

    <div className="shero-content">
      <h1 className="shero-title">
        <span className="stitle-part1">Polymath Kids Summer</span>
        <br />
        <span className="stitle-part2">Camp 2025</span>
        
      </h1>
      <p className="shero-description">
        Give your child a summer filled with purpose, creativity, and growth!
        Polymath-Kids' Summer Camp 2025 offers an exciting one-month journey
        packed with STEAM-based courses, live interactive sessions, and
        fun-filled learning experiences tailored for children aged 6 to 16.
        From coding and mental math to civil engineering and design, every
        child will explore something new—and walk away with a certificate and
        memories that last a lifetime.
      </p>

      <div className="shero-buttons">
        <button className="custom-btn orange-btn">
          <img src={pencilIcon} alt="icon" className="sbtn-icon" />
          Get Early Bird Discount
        </button>
        <button className="custom-btn yellow-btn">
          <img src={pencilIcon} alt="icon" className="sbtn-icon" />
          Book Free Demo Class
        </button>
      </div>
    </div>

    <div className="shero-right">
      <img src={rightimgs} alt="Kids Illustration" />
    </div>
  </div>
</section> */}
      <HeadSection
        leftImg={"Polymath-images/boy-with-laptop.png"}
        rightImg={"Polymath-images/kids-on-book.png"}
        titlePart1="Polymath Kids Summer"
        titlePart2="Camp 2025"
        description="Give your child a summer filled with purpose, creativity, and growth! Polymath-Kids' Summer Camp 2025 offers an exciting one-month journey packed with STEAM-based courses, live interactive sessions, and fun-filled learning experiences tailored for children aged 6 to 16. From coding and mental math to civil engineering and design, every child will explore something new—and walk away with a certificate and memories that last a lifetime."
        button1Text="Get Early Bird Discount"
        button2Text="Book Free Demo Class"
        button1Icon={'Polymath-images/Menu Pages/Clip path group.png'}
        button2Icon={'Polymath-images/Menu Pages/Clip path group.png'}
        onButton1Click={() => window.open("https://backend.polymath-kids.com/public/Documents/Summer%20Camp.jpeg", "_blank")}
        onButton2Click={() => window.open("https://backend.polymath-kids.com/public/Documents/Courses%summer%2025.pdf", "_blank")}
      />

      <div className="index-root">

        {/* Left side decorative image */}
        {/* <div className="left-img">
        <img
          src={leftimg}
          alt="Decorative calculator and supplies"
          style={{ width: "200px", objectFit: "contain" }}
          onLoad={() => setIsImageLoaded(true)}
        />
      </div> */}


        {/* Main content container */}
        {/* <div className="index-root"> */}
        <div className="index-container">

          {/* <h1 className="index-heading">
            Advantages of Taking Summer Courses from{" "}
            <span className="highlight">Polymath-Kids</span>
          </h1> */}

          <AdvantagesSection
            advantages={advantages}
            heading={"Advantages of Taking Summer Courses from"}
            subheading={"PolyMath Kids"}
          />
          {/* Advantages Cards */}
          {/* <div className="scards-grids">
            <div className="scard">
              <div className="scard-icon">
                <img src={info2} alt="Age-Specific Programs Icon" style={{ width: "80px", height: "80px", objectFit: "contain" }} />
              </div>
              <h3 className="scard-title">Live Classes</h3>
              <p className="scard-desc">
                Real-time, interactive sessions with expert instructors.
              </p>
            </div>
            <div className="scard">
              <div className="scard-icon">
                <img src={info3} alt="Age-Specific Programs Icon" style={{ width: "80px", height: "80px", objectFit: "contain" }} />
              </div>
              <h3 className="scard-title">Global Access</h3>
              <p className="scard-desc">Join from anywhere in the world.</p>
            </div>
            <div className="scard">
              <div className="scard-icon">
                <img src={info4} alt="Age-Specific Programs Icon" style={{ width: "80px", height: "80px", objectFit: "contain" }} />
              </div>
              <h3 className="scard-title">Wide Course Variety</h3>
              <p className="scard-desc">
                From coding to creativity—something for every child.
              </p>
            </div>
            <div className="scard">
              <div className="scard-icon">
                <img src={info5} alt="Age-Specific Programs Icon" style={{ width: "80px", height: "80px", objectFit: "contain" }} />
              </div>
              <h3 className="scard-title">Fast-Track Format</h3>
              <p className="scard-desc">
                Complete a full course in just weeks.
              </p>
            </div>
            <div className="scard">
              <div className="scard-icon">
                <img src={info6} alt="Age-Specific Programs Icon" style={{ width: "80px", height: "80px", objectFit: "contain" }} />
              </div>
              <h3 className="scard-title">Certified Completion</h3>
              <p className="scard-desc">
                Earn digital certificates for each course finished.
              </p>
            </div>
            <div className="scard">
              <div className="scard-icon">
                <img src={info7} alt="Age-Specific Programs Icon" style={{ width: "80px", height: "80px", objectFit: "contain" }} />
              </div>
              <h3 className="scard-title">Fun + Education</h3>
              <p className="scard-desc">
                Exciting lessons that keep kids engaged and learning.
              </p>
            </div>
           <div className="scard">
              <div className="scard-icon">
                <img src={info1} alt="Age-Specific Programs Icon" style={{ width: "80px", height: "80px", objectFit: "contain" }} />
              </div>
              <h3 className="scard-title">Age-Specific Programs</h3>
              <p className="scard-desc">
                Tailored content for every age group.
              </p>
            </div>
            <div className="scard">
              <div className="scard-icon">
                <img src={info8} alt="Age-Specific Programs Icon" style={{ width: "80px", height: "80px", objectFit: "contain" }} />
              </div>
              <h3 className="scard-title">Confidence Building</h3>
              <p className="scard-desc">
                Hands-on projects and participation videos.
              </p>
            </div>
            <div className="scard">
              <div className="scard-icon">
                <img src={info9} alt="Age-Specific Programs Icon" style={{ width: "80px", height: "80px", objectFit: "contain" }} />
              </div>
              <h3 className="scard-title">Big Summer Discounts</h3>
              <p className="scard-desc">
                Special pricing only available this summer.
              </p>
            </div>
          </div> */}
          {/* </div> 
         */}
          <br></br>
          {/* CTA Button with character illustration */}
          <div className="cta-row">
            <div className="cta-char">
              <div
                className="cta-char-inner"
              // style={{
              //   backgroundImage:
              //     'url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' viewBox=\'0 0 100 100\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Ccircle cx=\'50\' cy=\'40\' r=\'20\' fill=\'%233F51B5\'/%3E%3Crect x=\'35\' y=\'65\' width=\'30\' height=\'35\' fill=\'%233F51B5\'/%3E%3C/svg%3E")',
              // }}
              ></div>
            </div>
            <button className="custom-btn yellow-btn">
              <img src={pencilIcon} alt="icon" className="sbtn-icon" />
              Book Free Demo Class
            </button>
          </div>
        </div>
        <SumCourses heading="Our Popular Summer Courses" />
        {/* <PopularCourses/> */}
        {/* Expert Teachers Section */}
        <section className="expert-teachers-section">
          <div className="container">
            <h2 className="expert-teachers-title">
              <span className="learn-from">Learn from&nbsp;</span>
              <span className="expert-teachers">Expert Teachers</span>
            </h2>
            <div className="expert-teachers-content">
              <div className="mainframe-instructor-wrapper">
                <img
                  src={`${API_CONFIG.IMAGES_URL}/Polymath-images/Homepage/mainframeinstructor.png`}
                  alt="Expert Teachers"
                  className="mainframe-instructor-img"
                />
              </div>
              <div className="teachers-stats">
                <div className="stat-item">
                  <div className="stat-icon">
                    <img
                      src={require("../assets/hat.png")}
                      alt="Certified Instructors"
                    />
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-number">500+</h3>
                    <p className="stat-text">
                      Certified Instructors
                      <br />
                      Worldwide
                    </p>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <img src={require("../assets/Bulb.png")} alt="Experience" />
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-number">10+</h3>
                    <p className="stat-text">
                      Years Of Teaching
                      <br />
                      Experience
                    </p>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <img
                      src={require("../assets/femaleicon.png")}
                      alt="Female Teachers"
                    />
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-number">91%</h3>
                    <p className="stat-text">Female Teachers</p>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <img
                      src={require("../assets/bulbbook.png")}
                      alt="STEM Subjects"
                    />
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-number">15+</h3>
                    <p className="stat-text">
                      Coding & STEAM
                      <br />
                      Subjects
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <br></br>
        {/* <CertificateVerification/> */}
        <br></br>
        <br></br>


      </div>
      <Testimonials />
      <FAQ />
      {/* <section className="gallery-section">
              <div className="container">
                <div className="gallery-header">
                  <h2 className="gallery-title">
                    <span className="gallery-of">Gallery of </span>
                    <span className="learning-growth">Learning & Growth</span>
                  </h2>
                  <div className="sun-icon">
                    <img src={require("../assets/sun.png")} alt="Sun" />
                  </div>
                </div>
    
                <div className="gallery-grid">
                  {[...Array(8)].map((_, i) => (
                    <div className="gallery-item" key={i}>
                      <img
                        src={
                          require(`../assets/kid${i + 7}.png`) || "/placeholder.svg"
                        }
                        alt="Learning child"
                      />
                    </div>
                  ))}
                </div>
    
                <div className="calculator-icon">
                  <img src={require("../assets/calculator.png")} alt="Calculator" />
                </div>
    
                <div className="gallery-button">
                  <Link to="/gallery">
                    <img
                      src={require("../assets/viewgallery.png")}
                      alt="View Gallery"
                    />
                  </Link>
                </div>
              </div>
            </section> */}
      <div>
        <GallerySection />
      </div>
      <Footer />
    </>
  );
};

export default LifeSkillCourses;